import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Import React Router components
import './index.css';
import App from './App';
import CloseMe from './CloseMe'; // Import CloseMe component
import Error from './Error'; // Import CloseMe component
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Router> {/* Wrap the whole app in Router */}
      <Routes>
        {/* Define Routes */}
        <Route path="/" element={<App />} />  {/* Home Route */}
        <Route path="/closeme" element={<CloseMe />} /> {/* CloseMe Page Route */}
        <Route path="/error" element={<Error />} /> {/* CloseMe Page Route */}
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
